import { fetcher } from '@commenda/utils';
import { TTPDocumentRecord } from './types';

type CompletePrerequisiteResult =
  | { ok: true; data: TTPDocumentRecord }
  | { ok: false; error: string };

const completePrerequisite = async (
  recordId: string,
  layer: string
): Promise<CompletePrerequisiteResult> => {
  const res = await fetcher(
    `tp-document-record/${recordId}/complete-prerequisite`,
    {
      method: 'POST',
      body: { layer },
    }
  );

  if (!res.ok) {
    return { ok: false, error: 'Failed to complete prerequisite' };
  }

  const data = (await res.json()) as TTPDocumentRecord;
  return { ok: true, data };
};

export { completePrerequisite };
export type { CompletePrerequisiteResult };
